// extracted by mini-css-extract-plugin
module.exports = {"skip":"skip--1v0UD"};